import * as React from 'react'
import styled from 'styled-components'

import { LinkButton } from '@espoon-voltti/react-components/elements/button'
import {
  Container,
  ContentAreaLanding
} from '@espoon-voltti/react-components/layout'

import { t } from '../../i18n'
import * as Session from '../../session'
import { BrowserSupport } from './browser-support'

// TODO(nuora/user) fix in styleguide
const CustomContentAreaLanding = styled(ContentAreaLanding)`
  .title {
    text-align: center;
  }
`

export const Landing = () => (
  <Container>
    <CustomContentAreaLanding
      dataQa="landing"
      title={t(['views', 'landing', 'welcome', 'title'])}
      subtitle={t(['views', 'landing', 'welcome', 'subtitle'])}
    >
      <BrowserSupport />
      <LinkButton href={Session.loginUrl()} primary dataQa="loginBtn">
        {t(['views', 'landing', 'welcome', 'button'])}
      </LinkButton>
    </CustomContentAreaLanding>
  </Container>
)
